"use strict";
import { setupi18n } from "uniswap/src/i18n/i18n-setup-interface";
import "@reach/dialog/styles.css";
import "global.css";
import "polyfills";
import "tracing";
import { setupWagmiAutoConnect } from "components/Web3Provider/wagmiAutoConnect";
import * as WalletConnect from "@walletconnect/ethereum-provider";
if (WalletConnect) {
  console.debug("WalletConnect is defined");
}
setupi18n();
setupWagmiAutoConnect();
